import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['map', 'current', 'branch'];

  connect() {
    if (window.ymaps) {
      this.initMap();
    } else {
      this.loadScript();
    }
  }

  loadScript() {
    let script = document.createElement('script');
    const prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = (_, isAbort) => {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if (!isAbort) {
          this.initMap();
        }
      }
    };

    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&csp=true';
    prior.parentNode.insertBefore(script, prior);
  }

  initMap() {
    let controller = this;

    ymaps.ready(() => {
      const current = this.currentTarget;
      const map = new ymaps.Map(this.mapTarget.id, {
        center: [current.dataset.latitude, current.dataset.longitude],
        zoom: this.branchTarget.dataset.zoom
      });
      map.controls.add('zoomControl', { top: 75, left: 5 });
      map.behaviors.disable('scrollZoom');
      map.controls.remove('searchControl');

      var mkad_km = [
        [55.774558, 37.842762], [55.76522, 37.842789], [55.755723, 37.842627],
        [55.747399, 37.841828], [55.739103, 37.841217], [55.730482, 37.840175],
        [55.721939, 37.83916], [55.712203, 37.837121], [55.703048, 37.83262],
        [55.694287, 37.829512], [55.68529, 37.831353], [55.675945, 37.834605],
        [55.667752, 37.837597], [55.658667, 37.839348], [55.650053, 37.833842],
        [55.643713, 37.824787], [55.637347, 37.814564], [55.62913, 37.802473],
        [55.623758, 37.794235], [55.617713, 37.781928], [55.611755, 37.771139],
        [55.604956, 37.758725], [55.599677, 37.747945], [55.594143, 37.734785],
        [55.589234, 37.723062], [55.583983, 37.709425], [55.578834, 37.696256],
        [55.574019, 37.683167], [55.571999, 37.668911], [55.573093, 37.647765],
        [55.573928, 37.633419], [55.574732, 37.616719], [55.575816, 37.60107],
        [55.5778, 37.586536], [55.581271, 37.571938], [55.585143, 37.555732],
        [55.587509, 37.545132], [55.5922, 37.526366], [55.594728, 37.516108],
        [55.60249, 37.502274], [55.609685, 37.49391], [55.617424, 37.484846],
        [55.625801, 37.474668], [55.630207, 37.469925], [55.641041, 37.456864],
        [55.648794, 37.448195], [55.654675, 37.441125], [55.660424, 37.434424],
        [55.670701, 37.42598], [55.67994, 37.418712], [55.686873, 37.414868],
        [55.695697, 37.407528], [55.702805, 37.397952], [55.709657, 37.388969],
        [55.718273, 37.383283], [55.728581, 37.378369], [55.735201, 37.374991],
        [55.744789, 37.370248], [55.75435, 37.369188], [55.762936, 37.369053],
        [55.771444, 37.369619], [55.779722, 37.369853], [55.789542, 37.372943],
        [55.79723, 37.379824], [55.805796, 37.386876], [55.814629, 37.390397],
        [55.823606, 37.393236], [55.83251, 37.395275], [55.840376, 37.394709],
        [55.850141, 37.393056], [55.858801, 37.397314],
        [55.867051, 37.405588], [55.872703, 37.416601], [55.877041, 37.429429],
        [55.881091, 37.443596], [55.882828, 37.459065], [55.884625, 37.473096],
        [55.888897, 37.48861], [55.894232, 37.5016], [55.899578, 37.513206],
        [55.90526, 37.527597], [55.907687, 37.543443], [55.909388, 37.559577],
        [55.910907, 37.575531], [55.909257, 37.590344], [55.905472, 37.604637],
        [55.901637, 37.619603], [55.898533, 37.635961], [55.896973, 37.647648],
        [55.895449, 37.667878], [55.894868, 37.681721], [55.893884, 37.698807],
        [55.889094, 37.712363], [55.883555, 37.723636], [55.877501, 37.735791],
        [55.874698, 37.741261], [55.862464, 37.764519], [55.861979, 37.765992],
        [55.850257, 37.788216], [55.850383, 37.788522], [55.844167, 37.800586],
        [55.832707, 37.822819], [55.828789, 37.829754], [55.821072, 37.837148],
        [55.811599, 37.838926], [55.802781, 37.840004], [55.793991, 37.840965],
        [55.785017, 37.841576]
      ];
      var mkadObject = new ymaps.GeoObject({
        geometry: {
          type: "Polygon",
          coordinates: [
            mkad_km
          ]
        },
        properties: {
          balloonContent: "Заказ на сумму от 3 000 рублей, размещенный до 17:00, на следующий день в пределах МКАД доставляется БЕСПЛАТНО"
        }
      }, {
        fillColor: '#c92a2a',
        strokeColor: '#c92a2a',
        opacity: 0.5,
        strokeWidth: 2,
      });

      map.geoObjects.add(mkadObject);

      var ckad_km = [
        [56.089644, 37.211049], [56.095479, 37.223095], [56.100987, 37.235043],
        [56.106690, 37.247404], [56.112136, 37.260303], [56.117000, 37.273922], [56.120237, 37.288573],
        [56.122846, 37.303935], [56.127763, 37.317212], [56.134651, 37.326842], [56.143002, 37.334576],
        [56.150715, 37.343020], [56.158150, 37.352911], [56.165834, 37.365029], [56.171262, 37.375243],
        [56.176479, 37.386669], [56.181610, 37.399902], [56.186053, 37.413825], [56.189540, 37.428495],
        [56.191989, 37.443937], [56.193347, 37.459990], [56.193993, 37.476043], [56.193747, 37.492302],
        [56.192285, 37.508256], [56.192350, 37.524336], [56.192385, 37.540398], [56.192500, 37.556388],
        [56.192385, 37.572109], [56.189885, 37.587326], [56.185658, 37.601645], [56.182862, 37.616602],
        [56.179215, 37.631568], [56.175377, 37.646336], [56.171633, 37.661239], [56.168020, 37.676035],
        [56.164416, 37.690569], [56.160747, 37.705356], [56.157904, 37.720708], [56.156766, 37.736384],
        [56.154831, 37.751817], [56.152695, 37.767474], [56.150645, 37.783644], [56.148478, 37.799221],
        [56.145695, 37.814187], [56.140444, 37.827230], [56.134756, 37.839762], [56.131711, 37.854557],
        [56.130874, 37.870098], [56.129404, 37.885773], [56.126629, 37.901458], [56.123649, 37.916577],
        [56.120673, 37.931237], [56.114781, 37.943948], [56.109777, 37.957037], [56.103613, 37.968733],
        [56.096724, 37.979090], [56.090352, 37.990652], [56.084953, 38.003336], [56.084049, 38.018580],
        [56.082401, 38.033537], [56.076910, 38.047326], [56.074263, 38.063298], [56.071424, 38.078067],
        [56.066831, 38.092197], [56.062394, 38.106058], [56.057961, 38.119165], [56.053407, 38.133035],
        [56.049003, 38.146770], [56.044417, 38.160900], [56.042255, 38.176037], [56.040847, 38.191452],
        [56.036030, 38.205089], [56.029763, 38.217081], [56.024863, 38.230152], [56.020310, 38.244030],
        [56.015711, 38.257505], [56.011057, 38.271492], [56.005838, 38.283538], [55.999002, 38.291884],
        [55.990035, 38.297840], [55.981258, 38.304649], [55.975622, 38.315878], [55.972187, 38.330709],
        [55.968912, 38.345738], [55.964503, 38.359356], [55.964503, 38.359356], [55.953503, 38.385192],
        [55.950227, 38.399861], [55.947636, 38.415276], [55.943699, 38.429030], [55.937261, 38.440106],
        [55.929893, 38.449547], [55.922989, 38.459698], [55.920542, 38.474071], [55.923907, 38.489118],
        [55.928784, 38.502853], [55.929061, 38.517765], [55.923932, 38.529704], [55.914983, 38.534123],
        [55.906229, 38.536899], [55.897145, 38.539441], [55.888432, 38.542289], [55.880581, 38.548002],
        [55.872077, 38.553545], [55.862712, 38.553886], [55.853885, 38.548550], [55.846199, 38.542298],
        [55.837581, 38.540645], [55.828784, 38.545065], [55.821563, 38.554201], [55.813900, 38.562474],
        [55.805093, 38.565852], [55.796314, 38.565232], [55.787012, 38.563714], [55.777889, 38.559788],
        [55.770583, 38.552198], [55.764521, 38.540807], [55.760464, 38.526829], [55.756498, 38.513525],
        [55.748883, 38.505548], [55.739944, 38.502018], [55.732078, 38.493906], [55.725732, 38.484563],
        [55.716610, 38.480997], [55.708536, 38.472715], [55.704930, 38.458818], [55.700278, 38.444831],
        [55.694302, 38.432228], [55.687903, 38.422184], [55.681427, 38.412312], [55.674453, 38.401963],
        [55.667980, 38.391372], [55.661455, 38.380521], [55.654858, 38.369184], [55.648128, 38.359626],
        [55.638851, 38.358449], [55.630711, 38.362707], [55.622106, 38.364315], [55.613483, 38.365222],
        [55.603797, 38.369804], [55.596590, 38.377781], [55.588613, 38.384078], [55.580279, 38.387689],
        [55.571505, 38.390546], [55.563040, 38.394301], [55.554038, 38.398065], [55.544784, 38.402080],
        [55.535840, 38.404721], [55.526984, 38.405700], [55.518041, 38.405116], [55.508906, 38.403517],
        [55.500137, 38.401442], [55.491335, 38.395990], [55.485520, 38.384518], [55.482194, 38.370837],
        [55.477475, 38.358090], [55.470362, 38.347993], [55.463437, 38.338569], [55.454560, 38.333808],
        [55.445635, 38.333107], [55.436571, 38.332649], [55.427887, 38.335030], [55.418609, 38.338381],
        [55.410111, 38.341713], [55.401744, 38.343806], [55.392603, 38.341588], [55.384400, 38.334096],
        [55.378125, 38.323918], [55.373542, 38.311000], [55.367208, 38.299331], [55.359057, 38.291120],
        [55.354932, 38.278131], [55.354794, 38.262617], [55.354783, 38.246788], [55.355771, 38.231104],
        [55.356790, 38.215778], [55.357706, 38.200076], [55.358243, 38.184077], [55.357225, 38.168689],
        [55.354707, 38.153660], [55.352066, 38.138469], [55.351216, 38.123018], [55.350121, 38.107181],
        [55.346625, 38.092691], [55.344239, 38.077645], [55.344224, 38.062005], [55.344280, 38.047021],
        [55.342550, 38.031534], [55.339319, 38.015912], [55.338275, 38.000336], [55.339519, 37.984229],
        [55.341178, 37.968733], [55.345923, 37.956049], [55.351032, 37.943041], [55.352470, 37.927752],
        [55.353038, 37.912777], [55.350791, 37.898008], [55.347280, 37.883069], [55.344874, 37.867870],
        [55.344224, 37.852302], [55.342713, 37.837264], [55.340410, 37.821876], [55.338950, 37.805114],
        [55.337824, 37.790130], [55.335878, 37.775326], [55.334649, 37.758868], [55.334055, 37.743157],
        [55.333205, 37.727850], [55.332632, 37.712309], [55.332468, 37.696229], [55.332581, 37.680598],
        [55.332529, 37.665246], [55.332294, 37.649472], [55.332058, 37.633715], [55.331782, 37.617869],
        [55.330937, 37.602660], [55.328033, 37.587587], [55.327116, 37.572055], [55.329636, 37.556765],
        [55.332811, 37.542833], [55.336293, 37.529043], [55.339370, 37.512973], [55.341044, 37.497701],
        [55.342073, 37.482358], [55.343748, 37.466799], [55.348252, 37.452821], [55.354609, 37.442077],
        [55.361554, 37.433049], [55.368738, 37.423527], [55.375930, 37.413080], [55.381260, 37.400441],
        [55.384753, 37.385951], [55.387893, 37.371353], [55.390010, 37.356109], [55.390936, 37.340271],
        [55.391672, 37.324479], [55.392296, 37.308597], [55.393129, 37.293325], [55.393891, 37.277668],
        [55.395118, 37.261938], [55.399765, 37.248320], [55.405250, 37.235833], [55.410694, 37.223392],
        [55.416197, 37.211013], [55.421792, 37.198796], [55.427285, 37.185869], [55.430212, 37.171298],
        [55.435493, 37.158479], [55.441407, 37.146756], [55.446973, 37.134503], [55.452242, 37.121289],
        [55.459496, 37.102910], [55.465345, 37.089597], [55.470811, 37.077047], [55.476368, 37.064426],
        [55.481837, 37.052334], [55.488382, 37.041447], [55.494930, 37.030425], [55.501442, 37.019537],
        [55.508019, 37.008649], [55.514508, 36.997941], [55.520859, 36.987162], [55.528523, 36.978619],
        [55.535799, 36.985886], [55.542971, 36.987979], [55.552332, 36.991339], [55.560540, 36.992785],
        [55.569113, 36.997151], [55.577974, 36.999783], [55.586776, 37.002262], [55.594214, 37.006341],
        [55.603207, 37.005388], [55.610702, 37.010796], [55.619305, 37.014803], [55.626238, 37.020417],
        [55.630832, 37.004670], [55.634425, 36.999478], [55.641011, 36.993495], [55.650592, 36.987350],
        [55.657763, 36.979418], [55.658891, 36.964605], [55.662476, 36.949711], [55.666294, 36.935140],
        [55.670133, 36.920722], [55.673935, 36.906834], [55.680123, 36.895659], [55.687944, 36.887179],
        [55.696047, 36.880217], [55.704342, 36.878591], [55.712269, 36.873022], [55.721341, 36.874243],
        [55.729133, 36.879804], [55.738799, 36.877639], [55.746583, 36.884799], [55.753722, 36.891249],
        [55.761968, 36.898273], [55.769975, 36.905253], [55.778137, 36.912071], [55.786131, 36.918899],
        [55.794872, 36.921504], [55.803530, 36.920057], [55.812621, 36.918584], [55.821689, 36.917928],
        [55.830437, 36.920345], [55.839375, 36.922806], [55.848478, 36.925897], [55.856270, 36.933209],
        [55.863272, 36.939793], [55.873092, 36.942372], [55.882045, 36.943800], [55.891219, 36.944501],
        [55.900027, 36.944914], [55.906915, 36.945264], [55.914650, 36.945875], [55.926418, 36.948238],
        [55.934442, 36.956367], [55.942257, 36.964246], [55.949934, 36.972492], [55.957792, 36.980505],
        [55.965395, 36.988626], [55.973179, 36.996756], [55.980538, 37.006062], [55.987598, 37.015836],
        [55.995564, 37.022951], [56.004443, 37.026184], [56.013341, 37.028529], [56.020788, 37.036767],
        [56.025301, 37.049756], [56.030140, 37.063312], [56.034868, 37.077281], [56.039686, 37.090854],
        [56.044277, 37.104545], [56.049028, 37.118172], [56.053839, 37.131844], [56.059459, 37.144600],
        [56.062972, 37.158794], [56.066364, 37.173176], [56.073002, 37.184764], [56.079141, 37.194169],
        [56.083918, 37.201706]
      ];

      var ckadObject = new ymaps.Polygon([
        ckad_km,
        mkad_km
      ], {
        balloonContent: "Заказ на сумму от 20 000 рублей, размещенный до 17:00, на следующий день в пределах Малого бетонного кольца (А-107) доставляется БЕСПЛАТНО"
      }, {
        fillColor: '#2b8a3e',
        opacity: 0.5,
        strokeWidth: 0
      });

      map.geoObjects.add(ckadObject);

      var aksai_km = [
        [41.993627, 48.337239], [42.075557, 48.249378], [42.491375, 46.884420],
        [42.667227, 46.210893], [42.656561, 44.643288], [43.289611, 41.623500],
        [43.401353, 39.951036], [43.416996, 39.922973], [43.580333, 39.710764],
        [43.899523, 39.332681], [43.958427, 39.270104], [44.031430,39.143373],
        [44.050044, 39.125059], [44.095672, 39.064914], [44.098556, 39.036601],
        [44.138055, 39.023265], [44.168852, 38.965349], [44.190271, 38.885832],
        [44.240323, 38.829885], [44.247515, 38.819170], [44.252417, 38.820739],
        [44.301917, 38.746308], [44.307176, 38.705217], [44.358227, 38.527730],
        [44.369835, 38.390359], [44.388542, 38.336996], [44.417203, 38.207166],
        [44.551249, 38.048620], [44.633720, 37.908887], [44.649775, 37.931396],
        [44.735041, 37.787273], [44.680834, 37.806223], [44.674302, 37.798888],
        [44.667404, 37.797855], [44.653992, 37.753281], [44.652951, 37.698464],
        [44.668896, 37.654355], [44.669642, 37.627346], [44.678660, 37.560729],
        [44.686675, 37.517676], [44.694483, 37.485801], [44.707911, 37.456039],
        [44.758603, 37.381159], [44.890429, 37.296807], [44.981775, 37.249664],
        [45.122337, 36.709663], [44.430664, 34.128633], [44.387635, 33.738629],
        [44.499504, 33.488489], [44.583471, 33.379179], [44.636245, 33.517431],
        [44.792517, 33.535793], [44.838134, 33.554438], [44.975300, 33.599122],
        [45.186454, 33.376521], [45.149189, 33.280125], [45.315713, 32.652486],
        [45.346941, 32.493814], [45.390831, 32.480322], [45.517332, 32.681213],
        [45.585563, 32.822249], [45.787122, 33.169619], [45.969944, 33.770331],
        [45.981594, 33.838423], [45.969550, 33.966846], [45.892172, 34.558964],
        [45.685275, 34.971201], [45.256856, 35.394874], [45.429067, 35.824841],
        [45.468239, 36.162676], [45.432187, 36.592668], [45.441983, 36.840141],
        [45.331149, 37.342413], [45.745141, 37.785930], [46.369104, 37.988995],
        [46.682066, 37.735849], [46.711941, 38.272655], [47.290465, 39.144307],
        [47.775826, 39.791235], [48.188045, 40.266383], [48.931789, 44.635018],
        [48.302713, 46.196526], [48.282893, 46.218748], [46.546911, 48.632576],
        [46.114427, 48.067548], [44.390673, 46.586996]
      ];
      var aksaiObject = new ymaps.GeoObject({
        geometry: {
          type: "Polygon",
          coordinates: [
            aksai_km
          ]
        },
        properties: {
          balloonContent: "Заказ на сумму от 10 000 рублей, размещенный до 17:00, на следующий день в пределах зоны доставки доставляется БЕСПЛАТНО"
        }
      }, {
        fillColor: '#acc92a',
        strokeColor: '#acc92a',
        opacity: 0.5,
        strokeWidth: 2,
      });

      map.geoObjects.add(aksaiObject);

      var mbk_km = [
        [56.334732, 36.733909], [56.364097, 36.765215], [56.379656, 36.837763],
        [56.420259, 36.960895], [56.413951, 37.036533],
        [56.427349, 37.103853], [56.410500, 37.229276], [56.371845, 37.365514],
        [56.405783, 37.536616], [56.403696, 37.642213], [56.427702, 37.794558],
        [56.429509, 37.945673], [56.380388, 38.076495], [56.365749, 38.188320],
        [56.352128, 38.227663],
        [56.298412, 38.356913], [56.239328, 38.475437], [56.162005, 38.555719],
        [56.099431, 38.662331], [56.027197, 38.756528], [55.940089, 38.793907],
        [55.867430, 38.879355], [55.805058, 38.970175], [55.730618, 38.954068],
        [55.648270, 38.930074], [55.579510, 38.888877], [55.491360, 38.873354],
        [55.415083, 38.796333], [55.346983, 38.702863], [55.299445, 38.570883],
        [55.249212, 38.443600], [55.179889, 38.344884], [55.123451, 38.226702],
        [55.101674, 38.076108], [55.075850, 37.930626], [55.063143, 37.778613],
        [55.038815, 37.638395], [55.030958, 37.483175], [54.986093, 37.318173],
        [55.022128, 37.172763], [55.057945, 37.035626], [55.100942, 36.898219],
        [55.145797, 36.761469], [55.208286, 36.626156], [55.267753, 36.514953],
        [55.345519, 36.436423], [55.423754, 36.358718], [55.511159, 36.346753],
        [55.601971, 36.357748], [55.668752, 36.262715], [55.740436, 36.226190],
        [55.815534, 36.298576], [55.877703, 36.409554], [55.960382, 36.439549],
        [56.039097, 36.499278], [56.115574, 36.564603], [56.196847, 36.627108],
        [56.280521, 36.676973], [56.331294, 36.723156]
      ];
      var mbkObject = new ymaps.GeoObject({
        geometry: {
          type: "Polygon",
          coordinates: [
            mbk_km,
            ckad_km
          ]
        },
        properties: {
          balloonContent: "Заказ на сумму от X рублей, размещенный до 17:00, на следующий день в пределах МКБ доставляется БЕСПЛАТНО"
        }
      }, {
        fillColor: '#2a87c9',
        strokeColor: '#2a87c9',
        opacity: 0.5,
        strokeWidth: 2,
      });

      map.geoObjects.add(mbkObject);

      var deliveryZones = ymaps.geoQuery([ckadObject, mkadObject, aksaiObject, mbkObject]).addToMap(map);
      const boundsCollection = new ymaps.GeoObjectCollection();
      const current_placemark = new ymaps.Placemark(
        [current.dataset.latitude, current.dataset.longitude],
        {
          balloonContentHeader: current.dataset.name,
          balloonContentBody: current.dataset.address,
          hintContent: current.dataset.name
        },
        {
          openEmptyBalloon: true,
          preset: `islands#${current.dataset.color}PersonCircleIcon`
        }
      );

      boundsCollection.add(current_placemark);

      const branch = new ymaps.Placemark(
        [this.branchTarget.dataset.latitude, this.branchTarget.dataset.longitude],
        {
          hintContent: `Филиал: ${this.branchTarget.dataset.city}`
        },
        {
          preset: 'islands#redHomeCircleIcon'
        }
      );

      boundsCollection.add(branch);

      var coords = current_placemark.geometry.getCoordinates();
      var polygon = deliveryZones.searchContaining(coords).get(0);

      if (polygon) {
        deliveryZones.setOptions('opacity', 0.5);
        polygon.options.set('opacity', 0.7);
      } else {
        deliveryZones.setOptions('opacity', 0.5);
      }


      // debugger;
      map.geoObjects.add(boundsCollection);

      this.map = map;

    });
  }

}
